import { __assign, __read } from "tslib";
import * as u from './urx';
import { domIOSystem } from './domIOSystem';
export var windowScrollerSystem = u.system(function (_a) {
    var _b = __read(_a, 1), _c = _b[0], scrollTo = _c.scrollTo, scrollContainerState = _c.scrollContainerState;
    var windowScrollContainerState = u.stream();
    var windowViewportRect = u.stream();
    var windowScrollTo = u.stream();
    var useWindowScroll = u.statefulStream(false);
    var customScrollParent = u.statefulStream(undefined);
    u.connect(u.pipe(u.combineLatest(windowScrollContainerState, windowViewportRect), u.map(function (_a) {
        var _b = __read(_a, 2), _c = _b[0], viewportHeight = _c.viewportHeight, windowScrollTop = _c.scrollTop, scrollHeight = _c.scrollHeight, offsetTop = _b[1].offsetTop;
        return {
            scrollTop: Math.max(0, windowScrollTop - offsetTop),
            scrollHeight: scrollHeight,
            viewportHeight: viewportHeight,
        };
    })), scrollContainerState);
    u.connect(u.pipe(scrollTo, u.withLatestFrom(windowViewportRect), u.map(function (_a) {
        var _b = __read(_a, 2), scrollTo = _b[0], offsetTop = _b[1].offsetTop;
        return __assign(__assign({}, scrollTo), { top: scrollTo.top + offsetTop });
    })), windowScrollTo);
    return {
        // config
        useWindowScroll: useWindowScroll,
        customScrollParent: customScrollParent,
        // input
        windowScrollContainerState: windowScrollContainerState,
        windowViewportRect: windowViewportRect,
        // signals
        windowScrollTo: windowScrollTo,
    };
}, u.tup(domIOSystem));
